import { type FeatureName, type FeatureSet, featureNames } from "../constants/features";

/**
 * Filters a feature set to only include features currently in use
 * @param featureSet - the feature set to filter
 * @returns the set of features, filtered to features that are valid
 */
export function filterFeatureSet(featureSet: FeatureSet): FeatureSet {
  const filteredFeatures: Record<string, boolean> = {};
  for (const featureName in featureSet) {
    if (featureNames.includes(featureName as FeatureName)) {
      filteredFeatures[featureName] = !!featureSet[featureName as FeatureName];
    }
  }
  return filteredFeatures as FeatureSet;
}

export function emptyFeatureSet(): FeatureSet {
  return featureNames.reduce<FeatureSet>((acc, feature) => {
    acc[feature] = false;
    return acc;
  }, {} as FeatureSet);
}
